<template>
  
  <div id="prices-approval-segment" class="ui segment animated fadeIn" style="min-height: 220px;">

    <closeable-header-label label="Análise de Preços" @onClose="onCancel()"/>

    <div class="ui form m-t-15 m-b-20">      
      <div class="inline fields">
        <div class="field">
          <div class="ui radio checkbox prices-approval-checkbox">
            <input type="radio" class="hidden" value="only_not_approved" v-model="filter">
            <label>Somente não aprovados</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox prices-approval-checkbox">
            <input type="radio" class="hidden" value="all" v-model="filter">
            <label>Todos os itens</label>
          </div>
        </div>
      </div>
    </div>

    <div v-if="filter == 'only_not_approved' && filteredItems.length == 0" class="ui label m-t-10">
      <i class="info circle icon"></i> Todos os itens possuem algum valor aprovado
    </div>

    <product-segment v-for="item in filteredItems" :key="item.item" 
      :quotation="quotation" :item="item" @onUpdate="onUpdate"/>

    <div class="ui divider" style="margin-top: 50px !important;"></div>

    <button class="ui basic button m-t-15" @click="onCancel()">
      <i class="reply icon"></i> Cancelar
    </button>

  </div>

</template>

<script>

  import _ from "underscore"
  import { AppBrowser, Input, Loader, Scroll } from "@/utils"
  import QuotationService from "@/services/quotation-service"
  import CloseableHeaderLabel from "@/components/closeable-header-label.vue"
  import ProductSegment from "./product-segment.vue"

  export default {
    
    data() {
      return {
        loading: false,      
        updatedItems: [],
        filter: "only_not_approved",
      }
    },

    computed: {

      filteredItems() {

        let filteredItems = []
        const items = _.sortBy(this.quotation.items, "description")

        items.forEach((item) => {
                    
          if (this.filter == "only_not_approved" && item.appPrice > 0)
            return

          if (this.updatedItems.toString().indexOf(item.item) > -1)
            return  

          filteredItems.push(item)
        })

        return filteredItems
      },
    },

    props: ["quotation"],

    components: {
      CloseableHeaderLabel,
      ProductSegment,
    },    

    mounted() {      
      $(".prices-approval-checkbox").checkbox() 
    },

    methods: {

      onCancel() {
        this.$emit("onCancel")
      },

      onUpdate(item) {

        this.updatedItems.push(item.item)
        
        this.$emit("onUpdate")

        if (this.filteredItems.length == 0)
          this.onCancel()
      },
    },

  }

</script>

